var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.submission)?_c('Viewer',{attrs:{"data":_vm.submission}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }